import { actions } from 'react-redux-form';
import { httpGet } from "../../../../../utils/api.utils";

import {
    getCircuitEquipList,
    getCircuitOrderEquipList,
    deleteCircuitEquipItem,
    addCircuitEquipItem,
    updateCircuitEquipItem,
    resetCircuitEquipDetails,
    circuitEquipFormModel,
    onServiceModelSelect,
    getDeviceModelsAction,
    setDeviceModelsLoading,
    getAccessoryModelsAction,
    setAccessoryModelsLoading
} from "../../../../../constants/model-reducers/external/reports/inventory/details-view/add-equipment.settings";

import { compareIgnoreCase } from "../../../../../utils/helpers.utils";
export const circuitEquipFormInitialState = circuitEquipFormModel;

const defaultState = () => ({
    circuitEquipList: {
        datatable: []
    },
    equipTypes: [],
    equipModels: [],
    equipDevices: [],
    equipAccessories: [],
    equipStatuses: [],
    deviceModelsPage: 1,
    accessoryModelsPage: 1,
    hasMoreDeviceModels: true,
    hasMoreAccessoryModels: true,
    isDeviceModelsLoading: false,
    isAccessoryModelsLoading: false
});

const initialState = defaultState();

export const inventoryCircuitEquipActions = {
    getCircuitEquipList: (circuitId, vendorId = 0, circuitTypeId = 0) => async (dispatch, state) => {
        var data = await httpGet('external/inventory/getCircuitEquipList/' + circuitId + "/" + vendorId + "/" + circuitTypeId);
        await dispatch(inventoryCircuitEquipActions.getDeviceModels(vendorId, circuitTypeId, 1, ''));
        await dispatch(inventoryCircuitEquipActions.getAccessoryModels(vendorId, circuitTypeId, 1, ''));
        dispatch({
            type: getCircuitEquipList,
            datatable: data.datatable,
            equipTypes: data.equipTypes,
            equipModels: data.equipModels,
            equipStatuses: data.equipStatuses
        });
    },

    getCircuitOrderEquipList: (vendorId = 0, orderId, requestTypeId, orderCircuitDetailId = 0, circuitTypeId = 0) => async (dispatch, state) => {
        var data = await httpGet('external/order/getCircuitOrderEquipList/' + vendorId + "/" + orderId + "/" + requestTypeId+ '/' + orderCircuitDetailId + '/' + circuitTypeId);
        await dispatch(inventoryCircuitEquipActions.getDeviceModels(vendorId, circuitTypeId, 1, ''));
        await dispatch(inventoryCircuitEquipActions.getAccessoryModels(vendorId, circuitTypeId, 1, ''));

        dispatch({
            type: getCircuitOrderEquipList,
            datatable: data.datatable,
            equipTypes: data.equipTypes,
            equipModels: data.equipModels,
            equipStatuses: data.equipStatuses
        });
    },

    onServiceModelSelect: (model, value) => async (dispatch, state) => {
        if (value == null || value === "" || value === undefined) {
            // Clear the form fields
            dispatch(actions.reset(model));
            dispatch(actions.reset("inventoryCircuitEquipForm.ProductName"));
            dispatch(actions.reset("inventoryCircuitEquipForm.Price"));
        } else {
            // Fetch model data
            const data = await httpGet('external/inventory/getCircuitEquipModelList/' + value);

            // If no data returned, treat as undefined
            const selectedModel = data?.dataModel?.[0];
            if (!selectedModel) {
                dispatch(actions.reset(model));
                dispatch(actions.reset("inventoryCircuitEquipForm.Model"));
                dispatch(actions.reset("inventoryCircuitEquipForm.ModelId"));
                dispatch(actions.reset("inventoryCircuitEquipForm.ProductName"));
                dispatch(actions.reset("inventoryCircuitEquipForm.Price"));
            } else {
                // Set form fields with returned data
                dispatch(actions.change(model, selectedModel.EquipmentId));
                dispatch(actions.change("inventoryCircuitEquipForm.ProductName", selectedModel.ProductName));
                dispatch(actions.change("inventoryCircuitEquipForm.Price", selectedModel.Price));
            }
        }
    },

    getDeviceModels: (vendorId, circuitTypeId, page = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;

        dispatch({ type: setDeviceModelsLoading, payload: true });

        let url = `external/inventory/getDeviceModels/${vendorId}/${circuitTypeId}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            dispatch({
                type: getDeviceModelsAction,
                payload: { deviceModels: res, deviceModelsPage: page }
            });
            dispatch({ type: setDeviceModelsLoading, payload: false });
        } catch (err) {
            dispatch({ type: setDeviceModelsLoading, payload: false });
        }
    },
    getAccessoryModels: (vendorId, circuitTypeId, page = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;

        dispatch({ type: setAccessoryModelsLoading, payload: true });

        let url = `external/inventory/getAccessoryModels/${vendorId}/${circuitTypeId}/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            dispatch({
                type: getAccessoryModelsAction,
                payload: { accessoryModels: res, accessoryModelsPage: page }
            });
            dispatch({ type: setAccessoryModelsLoading, payload: false });
        } catch (err) {
            dispatch({ type: setAccessoryModelsLoading, payload: false });
        }
    },

    deleteCircuitEquipItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var newDataItem = [...dataItem];
        newDataItem.splice(index, 1);

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: deleteCircuitEquipItem,
            datatable: newDataTable
        });
    },
    addCircuitEquipItem: () => (dispatch, state) => {
        const { equipTypes, equipModels, equipDevices, equipAccessories, equipStatuses } = state().inventoryCircuitEquip;
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;
        const { inventoryCircuitEquipForm } = state().form;

        var dataItem = datatable[0]?.dataItem;
        var HeaderItem = datatable[0]?.HeaderItem;

        var EquipTypeValue = equipTypes?.filter(r => r.FilterValue == inventoryCircuitEquipForm.TypeId);
        var EquipModelValue = equipModels?.filter(r => r.FilterValue == inventoryCircuitEquipForm.ModelId);
        var EquipStatusValue = equipStatuses?.filter(r => r.FilterValue == inventoryCircuitEquipForm.StatusId);

        var newDataItem = [
            ...dataItem,
            {
                ...inventoryCircuitEquipForm,
                ID: -1,
                Type: EquipTypeValue.length > 0 ? EquipTypeValue[0]?.FilterName : null,
                Model: EquipModelValue.length > 0 ? EquipModelValue[0]?.FilterName : null,
                Status: EquipStatusValue.length > 0 ? EquipStatusValue[0]?.FilterName : null,
                Price: inventoryCircuitEquipForm.Price ? parseFloat(inventoryCircuitEquipForm.Price) : 0.00
            }
        ].sort((a, b) => compareIgnoreCase(a.Status || "", b.Status || ""));

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addCircuitEquipItem,
            datatable: newDataTable
        });
    },
    updateCircuitEquipItem: () => (dispatch, state) => {
        const { equipTypes, equipModels, equipDevices, equipAccessories, equipStatuses } = state().inventoryCircuitEquip;
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;
        const { inventoryCircuitEquipForm } = state().form;

        var dataItem = datatable[0]?.dataItem;
        var HeaderItem = datatable[0]?.HeaderItem;

        var indexItem = inventoryCircuitEquipForm.ID;
        var EquipTypeValue = equipTypes.filter(r => r.FilterValue == inventoryCircuitEquipForm.TypeId);
        var EquipModelValue = equipModels.filter(r => r.FilterValue == inventoryCircuitEquipForm.ModelId);
        var EquipStatusValue = equipStatuses.filter(r => r.FilterValue == inventoryCircuitEquipForm.StatusId);

        dataItem[indexItem] = {
            ...inventoryCircuitEquipForm,
            ID: dataItem[indexItem].ID,
            Type: EquipTypeValue.length > 0 ? EquipTypeValue[0]?.FilterName : null,
            Model: EquipModelValue.length > 0 ? EquipModelValue[0]?.FilterName : null,
            Status: EquipStatusValue.length > 0 ? EquipStatusValue[0]?.FilterName : null,
            Price: inventoryCircuitEquipForm.Price ? parseFloat(inventoryCircuitEquipForm.Price) : 0.00
        };

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateCircuitEquipItem,
            datatable: newDataTable
        });
    },
    viewCircuitEquipItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;

        var dataItem = datatable[0]?.dataItem[index];

        dataItem = {
            ...dataItem,
            ID: index
        };

        dispatch(actions.reset("inventoryCircuitEquipForm"));
        dispatch(actions.change("inventoryCircuitEquipForm", dataItem));

    },
    resetCircuitEquipForm: () => (dispatch, state) => {
        const formData = {
            ...circuitEquipFormModel,
        };

        dispatch(actions.change("inventoryCircuitEquipForm", formData));
    },
    resetCircuitEquipDetails: () => (dispatch, state) => {
        dispatch({
            type: resetCircuitEquipDetails,
            circuitEquipList: {
                datatable: []
            },
            equipTypes: [],
            equipModels: [],
            equipDevices: [],
            equipAccessories: [],
            equipStatuses: []
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitEquipList:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                },
                equipTypes: action.equipTypes,
                equipModels: action.equipModels,
                equipStatuses: action.equipStatuses
            };
        case getCircuitOrderEquipList:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                },
                equipTypes: action.equipTypes,
                equipModels: action.equipModels,
                equipStatuses: action.equipStatuses
            };
        case addCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case updateCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case deleteCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case onServiceModelSelect:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case resetCircuitEquipDetails:
            return {
                ...state,
                circuitEquipList: action.circuitEquipList,
                equipTypes: action.equipTypes,
                equipModels: action.equipModels,
                equipStatuses: action.equipStatuses
            };
        case getDeviceModelsAction: {
            const { deviceModels, deviceModelsPage } = action.payload;
            return {
                ...state,
                equipDevices: deviceModelsPage === 1 ? deviceModels : [...state.equipDevices, ...deviceModels],
                hasMoreDeviceModels: deviceModels.length > 0,
                deviceModelsPage
            };
        };
        case setDeviceModelsLoading:
            return { ...state, isDeviceModelsLoading: action.payload };

        case getAccessoryModelsAction: {
            const { accessoryModels, accessoryModelsPage } = action.payload;
            return {
                ...state,
                equipAccessories: accessoryModelsPage === 1 ? accessoryModels : [...state.equipAccessories, ...accessoryModels],
                hasMoreAccessoryModels: accessoryModels.length > 0,
                accessoryModelsPage
            };
        };
        case setAccessoryModelsLoading:
            return { ...state, isAccessoryModelsLoading: action.payload };
        default:
            return state;
    }
}